export const MERCHANT_PROVIDER_IMPORT_PERMISSIONS = ['view', 'import', 'edit', 'view_financial', 'edit_financial'];

export const canImportMerchantProviders = hasPermission => (
  MERCHANT_PROVIDER_IMPORT_PERMISSIONS.every(action => hasPermission('merchants', action))
);

export const isMerchantImportDependency = action => (
  action !== 'import' && MERCHANT_PROVIDER_IMPORT_PERMISSIONS.includes(action)
);
